import React from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { CaptionText, H3 } from '../../../styles/FontStyles';
import { useTranslation } from 'react-i18next';
import Countdown from 'react-countdown';
import { CountdownNumbers } from '../../EventPromo/EventPromoStyled';

export const CountdownComponent = ({ timestamp }: any) => {
  const { t } = useTranslation('myTeam');

  interface RendererProps {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }

  const renderer: React.FC<RendererProps> = ({
    days,
    hours,
    minutes,
    seconds,
    completed
  }: any) => {
    return (
      <div
        style={{
          width: 212,
          height: 212,
          position: 'relative',
          border: '3px solid #DBCEA2',
          borderRadius: '50%',
          padding: 3,
          background:
            'linear-gradient(316.54deg, #FADF7F -251.77%, #ECDEAF -92.56%, #000000 84.14%)'
        }}>
        <CountdownCircleTimer
          isPlaying={!completed}
          duration={60}
          colors={['#ffffff', '#ffffff']}
          trailColor={'#DBCEA2'}
          colorsTime={[60, 60]}
          onComplete={() => {
            return { shouldRepeat: true, delay: 0 };
          }}
          initialRemainingTime={seconds}
          size={200}
          strokeWidth={15}
          strokeLinecap={'square'}></CountdownCircleTimer>
        <div
          style={{
            width: 200,
            height: 200,
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
          <CountdownNumbers ticketPromotion={false}>
            <div>
              <H3>{days}</H3>
              <CaptionText caps> {t('days')}</CaptionText>
            </div>
            <div>
              <H3>{hours}</H3>
              <CaptionText caps> {t('hours')}</CaptionText>
            </div>
            <div>
              <H3>{minutes}</H3>
              <CaptionText caps> {t('minutes')}</CaptionText>
            </div>
          </CountdownNumbers>
        </div>
      </div>
    );
  };

  return (
    <div style={{ position: 'absolute', right: 50, top: 20 }}>
      <Countdown date={timestamp} renderer={renderer} />
    </div>
  );
};
